import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
import { RED } from "@/resources/constants/busyReasons";
import moment from "moment";
import { CONFIG, ConfigInterface } from "@/resources/constants/system";
@Component({})
export default class PaperPlane extends Vue {
  congratulateBirthday(description: string, fromUser: any, availableStatus: string) {
    const config: ConfigInterface = this.$store.getters["UserStore/getConfig"];
    const audio = new Audio(require("@/assets/audio/party_horn.mp3"));
    if (!config.notification.silenceNotification) {
      audio.play();
    }
    const options = {
      body: description,
      image: "https://assets-pro.nubi.city/nubii-us-blue.png",
      icon: "/src/assets/images/logo/nubii_blue.png",
      silent: config.notification.silenceNotification,
    };
    if (document.hidden) {
      const notification = new Notification(
        i18n
          .t("notifications.sendBirthdayCake", {
            name: fromUser.name,
            lastName: fromUser.lastName,
          })
          .toString(),
        options
      );
      setTimeout(notification.close.bind(notification), 5000);
    }
    this.$vs.notification({
      icon: '<i class="fas fa-birthday-cake" style="color: #2b3d8e"></i>',
      border: "primary",
      duration: "none",
      clickClose: true,
      position: "top-right",
      title: i18n.t("notifications.sendBirthdayCake", {
        name: fromUser.name,
        lastName: fromUser.lastName,
      }),
      text: `${description}<p style="text-align: end;font-size: 10px">${i18n.t(
        "labels.sentAt"
      )} ${moment().format("HH:mm")}</p>`,
      onDestroy: () => {
        audio.pause();
      },
    });
  }
  onNewPaperPlane(
    description: string,
    fromUser: any,
    availableStatus: string
  ): void {
    const config: ConfigInterface = this.$store.getters["UserStore/getConfig"];
    const audio =
      availableStatus != RED.type
        ? new Audio(require("@/assets/audio/goofy.mp3"))
        : new Audio(require("@/assets/audio/alert.mp3"));
    if (!config.notification.silenceNotification) {
      if (availableStatus == RED.type) this.retrySound(audio);
      else audio.play();
    }
    const options = {
      body: description,
      image: "https://assets-pro.nubi.city/nubii-us-blue.png",
      icon: "/src/assets/images/logo/nubii_blue.png",
      silent: config.notification.silenceNotification,
    };
    if (document.hidden) {
      const notification = new Notification(
        i18n
          .t("notifications.newPaperPlane", {
            name: fromUser.name,
            lastName: fromUser.lastName,
          })
          .toString(),
        options
      );
      setTimeout(notification.close.bind(notification), 5000);
    }

    this.$vs.notification({
      icon: '<i class="fas fa-paper-plane" style="color: #2b3d8e"></i>',
      border: "primary",
      //color: "primary",
      duration: "none",
      clickClose: true,
      position: "top-right",
      title: i18n.t("notifications.newPaperPlane", {
        name: fromUser.name,
        lastName: fromUser.lastName,
      }),
      text: `${description}<p style="text-align: end;font-size: 10px">${i18n.t(
        "labels.sentAt"
      )} ${moment().format("HH:mm")}</p>`,
      onDestroy: () => {
        audio.pause();
      },
    });
  }
  retrySound(audio: HTMLAudioElement): void {
    audio.loop = true;
    audio.play();
    setTimeout(() => {
      audio.pause();
    }, 7000);
  }
}
